import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import API_BASE from "../../config";
import PublicUserBadge from "../../components/PublicUserBadge";
import s from "./ArticleDetail.module.css";

function fmtDate(iso) {
  if (!iso) return "";
  return new Date(iso).toLocaleDateString(undefined, {
    year: "numeric", month: "long", day: "numeric",
  });
}

export default function ArticleDetailPage() {
  const { id } = useParams();
  const nav = useNavigate();
  const [article, setArticle] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true); setError("");
    fetch(`${API_BASE}/api/articles/${id}`)
      .then(r => {
        if (!r.ok) throw new Error(r.status === 404 ? "Article not found" : "Failed to load");
        return r.json();
      })
      .then(a => { if (!cancelled) setArticle(a); })
      .catch(e => { if (!cancelled) setError(e.message); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [id]);

  return (
    <div className={s.page}>
      {/* ── Top bar ── */}
      <header className={s.topbar}>
        <Link to="/" className={s.brand}>
          <img src="/ncla-logo.png" alt="NCLA logo" className={s.brandDot} />
          NCLA
        </Link>
        <div className={s.topActions}>
          <button className={s.backBtn} onClick={() => nav(-1)}>← Back</button>
          <Link to="/" className={s.homeBtn}>Home</Link>
          <PublicUserBadge variant="dark" compact />
        </div>
      </header>

      {loading && <div className={s.state}>Loading…</div>}
      {error && <div className={s.state}>{error}</div>}

      {article && (
        <article className={s.article}>
          <div className={s.meta}>
            <span className={`${s.badge} ${article.category === "EVENT" ? s.badgeEvent : s.badgeNews}`}>
              {article.category === "EVENT" ? "Event" : "News"}
            </span>
            <span className={s.date}>{fmtDate(article.postedAt)}</span>
            {article.postedByUsername && (
              <span className={s.author}>by {article.postedByUsername}</span>
            )}
          </div>

          <h1 className={s.title}>{article.title}</h1>

          {article.summary && (
            <p className={s.summary}>{article.summary}</p>
          )}

          {article.mediaUrl && (
            <div className={s.mediaWrap}>
              {article.mediaType === "video"
                ? <video src={article.mediaUrl} controls className={s.media} />
                : <img src={article.mediaUrl} alt={article.title} className={s.media} />
              }
            </div>
          )}

          <div className={s.body}>{article.body}</div>

          <div className={s.footer}>
            <Link to="/" className={s.backHome}>← Back to NCLA home</Link>
          </div>
        </article>
      )}
    </div>
  );
}
